import type { CSSProperties } from "react";
import { tokens } from "../theme";

const svgStyle: CSSProperties = {
  display: "block",
  color: tokens.text.muted,
};

/**
 * Three-dot typing indicator. Geometry matches `assets/brand/typing-dots.svg`.
 * Inlined so SMIL bounce runs (external `<img>` SVGs do not animate).
 */
export default function TypingIndicator({ label }: { label: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="18"
      viewBox="0 0 36 18"
      fill="currentColor"
      role="img"
      aria-label={label}
      style={svgStyle}
    >
      <circle cx="7" cy="12" r="3.2">
        <animate
          attributeName="cy"
          values="12;7;12"
          dur="0.85s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="18" cy="12" r="3.2">
        <animate
          attributeName="cy"
          values="12;7;12"
          dur="0.85s"
          begin="0.15s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="29" cy="12" r="3.2">
        <animate
          attributeName="cy"
          values="12;7;12"
          dur="0.85s"
          begin="0.3s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
}
